import { Button, Upload } from "antd";
import { useDispatch } from "react-redux";
import { uploadBulkPlayers } from "../../../store/actions/team.actions";
import { audioMessage as message } from "../../Common/Notifications/audioMessage";

export const OnboardingControl = ({ handleOpenAddModal, canAddPlayer }) => {
  const dispatch = useDispatch();

  const uploadProps = {
    customRequest: async ({ file, onSuccess, onError }) => {
      dispatch(uploadBulkPlayers(file));
    },
    accept: "text/csv",
    showUploadList: false,
  };

  const downloadCSV = () => {

    const csvHeaders = "First Name,Last Name,Position,Jersey #,Email";
    const blob = new Blob([csvHeaders], { type: 'text/csv;charset=utf-8;' });

    // Create a URL for the blob object
    const url = window.URL.createObjectURL(blob);
  
    // Create an <a> element and set its href to the blob URL
    const a = document.createElement('a');
    a.href = url;
    a.download = 'New Roster Template.csv';
  
    // Append the <a> element to the document body
    document.body.appendChild(a);
  
    // Programmatically click the <a> element to trigger the download
    a.click();
  
    // Clean up by revoking the object URL and removing the <a> element
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        gap: 16,
      }}
    >
      <Button type="primary" onClick={handleOpenAddModal} disabled={!canAddPlayer}>
        Add Player
      </Button>
      <Upload {...uploadProps}>
        <Button type="primary" disabled={!canAddPlayer}>Upload CSV</Button>
      </Upload>
        <Button type="primary" onClick={()=>downloadCSV()}>Download CSV Template</Button>
    </div>
  );
};
